import { BrandsAPI } from '@/api';
import { IGetBrandsDTO, IGetBrandsResponse, IUpdateBrandResponse, IUploadBrandDetailsDTO } from '@/models/brands.model';
import { IApiError } from '@/models/apiError.model';
import { formatApiError } from '@/utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { SLICE_NAME } from './models';

export const getBrands = createAsyncThunk<IGetBrandsResponse, IGetBrandsDTO, { serializedErrorType: IApiError }>(
  `${SLICE_NAME}/getBrands`,
  async (data) => {
    const response = await BrandsAPI.getBrands(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const uploadBrandDetails = createAsyncThunk<
  IUpdateBrandResponse,
  IUploadBrandDetailsDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/uploadBrandDetails`,
  async (data) => {
    const response = await BrandsAPI.uploadBrandDetails(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
